import gsap from 'gsap'

import { fadeRevealAnimation, getScrollTriggerOptions, type SharedAnimation } from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const storeHeroRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse, 'top top'),
    delay
  })

  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = fadeRevealAnimation(media)
    timeline.add(mediaAnimation.timeline, 0)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    mediaAnimation?.revert()
  }
}
